export const SET_DATA = 'SET_DATA'
export const SET_STYLE = 'SET_STYLE'
export const SET_METATDATA = 'SET_METADATA'
export const SET_CURRENT_BORDER_WIDTH = 'SET_BORDER_WIDTH'
export const SET_CURRENT_BORDER_COLOR = 'SET_BORDER_COLOR'
export const SET_TYPE_DONNEES = 'SET_TYPE_DONNEES'
export const SET_PROJECTS_LIST = 'SET_PROJECTS_LIST'
export const SET_TABLEAUX_LIST = 'SET_TABLEAUX_LIST'
export const DISABLED_ADD_TABLEAU = 'DISABLED_ADD_TABLEAU'
export const SET_ESPACE_FROM_TABLEAU = 'SET_ESPACE_FROM_TABLEAU'
export const SET_TABLEAU_BY_ID = 'SET_TABLEAU_BY_ID'
export const SET_CURRENT_PROJECT = 'SET_CURRENT_PROJECT'
export const SET_CURRENT_ONGLET = 'SET_CURRENT_ONGLET'
export const SET_LIST_ONGLET = 'SET_LIST_ONGLET'
export const SET_PERMISSION = 'SET_PERMISSION'
export const SET_FICHES = 'SET_FICHES'
export const SHOW_TYPE = 'SHOW_TYPE'
export const IS_PROJECT_TEMPLATE = 'IS_PROJECT_TEMPLATE'
export const IS_COPIED = 'IS_COPIED'
export const IS_CLONING_FORMAT = 'IS_CLONING_FORMAT'
export const IS_SELECTING_COLOR = 'IS_SELECTING_COLOR'



// WEBPACK FOOTER //
// ./src/store/modules/tableau/mutation_types.js